import { useEffect } from 'react';

import useUIConfigStore from 'stores/useUIConfigStore';

import { FeatureFlagKeys } from '../constants/flagKeys';
import useFliptStore from '../store/useFliptStore';

export default function useFliptBoolean(
  flagKey: FeatureFlagKeys,
  alwaysLoad?: boolean,
  namespaceKey?: string,
  enableGuest?: boolean,
): boolean {
  const featureFlags = useUIConfigStore((s) => s.getUIValue('featureFlags'));
  const loadBooleanEvaluation = useFliptStore((s) => s.loadBooleanEvaluation);
  const namespace = namespaceKey ?? undefined;
  const flag = featureFlags ? featureFlags[flagKey] : undefined;

  useEffect(() => {
    if (flag && !alwaysLoad) {
      return;
    }
    loadBooleanEvaluation(flagKey, namespace, enableGuest);
  }, [flagKey, flag, alwaysLoad, namespace]);

  return flag ? flag.isEnabled : false;
}
